import React from "react";
import ContactForm from "../components/ContactForm";
import ContactHero from "../components/ContactHero";

const Contact = () => {
  return (
    <>
      <div className="bg-light-gray">
        <ContactHero />
        <ContactForm />
      </div>
    </>
  );
};

export default Contact;
